import { render, staticRenderFns } from "./delConfirmModal.vue?vue&type=template&id=6d982fc4&"
import script from "./delConfirmModal.vue?vue&type=script&lang=js&"
export * from "./delConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports